import initBScroll from "@/utils/bScroll";
import { dateFormatMapping } from "@/utils";
import { iotAccess } from "@/api/request/snkd.produce";

const videoPoster = require("@/assets/images/bs/farm-detail/poster.jpg");
const VIDEO_ICON = require("@/assets/images/bs/farm-detail/icon-video.svg");
const STATION_FLAG = "ysqxz";
const DEIVCE_IDENTIFY = {
  CAMERA: "camera",
  GATEWAY: "gateway",
};
const farmdetailIotNewMixin = {
  data() {
    return {
      /* this is the new version of the data */
      // 是否有新版物联网数据判断标志
      newVersionFlag: null, // 传感设备总数
      totalSensor: 0, // 控制设备总数
      totalController: 0, // 网关设备Position
      markProductPosition: [],
      hisBsFlag: false,
      sensorHsBs: null,
      currentMarkerTarget: null, // 当前点击的marker的dom等信息
      currentMarkerData: {
        id: null,
        displayName: "",
      },
    };
  },
  mounted() {},
  methods: {
    // 初始化
    async _initIot() {
      const [cameraList, deviceList] = await this.getAllDevices();
      if (this.showShanghaiMap) {
        await this.OffsetAllPointerHander(cameraList);
        await this.OffsetAllPointerHander(deviceList);
      }
      this.getMarkerList({ cameraList, deviceList });
      this._initIotMark();
    },

    async getCameraListController() {
      const res = await iotAccess.cameraListService({
        farmId: this.farmId,
        pageNo: 1,
        pageSize: 200,
      });
      return res.list;
    },
    async getDeviceListController() {
      const res = await iotAccess.deviceListService({
        farmId: this.farmId,
        pageNo: 1,
        pageSize: 200,
      });
      return res.list;
    },
    getAllDevices() {
      return Promise.all([
        this.getCameraListController(),
        this.getDeviceListController(),
      ]);
    },
    // 统一格式marker点列表
    getMarkerList({ cameraList = [], deviceList = [] }) {
      cameraList.forEach((item) => {
        this.markProductPosition.push({
          ...item,
          id: item.cameraId,
          identify: DEIVCE_IDENTIFY.CAMERA,
          icon: VIDEO_ICON,
        });
      });

      deviceList.forEach(
        ({
          deviceName,
          deviceId,
          lat,
          lng,
          gateCategoryIdentifier,
          gateCategoryIcon,
        }) => {
          this.markProductPosition.push({
            id: deviceId,
            lat,
            lng,
            identify: DEIVCE_IDENTIFY.GATEWAY,
            displayName: deviceName,
            icon: gateCategoryIcon,
            isStation: gateCategoryIdentifier.includes(STATION_FLAG), // 是否是气象站，标识中含有 "ysqxz"
          });
        }
      );
    },
    // marker点的html模版
    _returnHtmlTemplate({ icon, identify }) {
      return `
				<div class="icon-inner ${identify}-icon">
				<header class="header">
					<img src="${icon}" class="icon-image"/>
				</header>
				<footer class="footer"></footer>
				</div>
			`;
    },
    // 打点
    _initIotMark() {
      const { markProductPosition } = this;
      markProductPosition.forEach((item) => {
        this._initMarker(item);
      });
    },
    // 初始化marker点
    _initMarker(deviceVO) {
      const { _returnHtmlTemplate } = this;
      const { map } = this;
      const { icon, identify, displayName, lat, lng } = deviceVO;
      const myIcon = L.divIcon({
        className: "my-div-icon",
        iconAnchor: [32 / 2, 47], //偏移位置
        html: _returnHtmlTemplate({ identify, icon }),
        iconSize: [32, 47],
      });
      const marker = L.marker([lat, lng], {
        icon: myIcon,
        title: displayName,
        draggable: false,
      }).addTo(map);
      marker.on("click", ({ target }) => {
        this.$emit("closeAll"); //触发父级事件 关闭当前页面所有弹框
        this._clickMarkerHandle(target, deviceVO);
      });
    },
    // 点击marker点的回调
    async _clickMarkerHandle(target, deviceVO) {
      const { id, identify, lat, lng } = deviceVO;
      const { currentMarkerData } = this;
      if (currentMarkerData) {
        const { id: prevId, identify: prevIdentify } = currentMarkerData;
        // 如果已经选中，则不需要以下操作
        if (id === prevId && identify === prevIdentify) return;
      }
      layer.closeAll();
      await this.setAsyncFun(300); // closeAll似乎是异步的，不等待一下会有问题
      this._mapMovePos({ lat, lng });
      this.currentMarkerTarget &&
        this._removeMarkerActiveClass(this.currentMarkerTarget._icon);
      // 赋值新的数据
      this.currentMarkerTarget = target;
      this.currentMarkerData = deviceVO;
      // 打开摄像头弹窗
      if (identify === DEIVCE_IDENTIFY.CAMERA) {
        this._initVideoLayer();
        this.dialogVisible = true;
      } else if (identify === DEIVCE_IDENTIFY.GATEWAY) {
        this._initGatewayLayer();
      }
      // 添加active状态
      this._setMarkerActiveClass(target._icon);
    },
    // 设置选中的marker点的active
    _setMarkerActiveClass(dom) {
      dom.classList.add("active");
    },
    // 去除marker点的active
    _removeMarkerActiveClass(dom) {
      dom.classList.remove("active");
    },
    // 移动map
    async _mapMovePos(coordinate) {
      const { map } = this;
      await this.setAsyncFun();
      const mapLatLng = map.getBounds(); // 地图右上角 左下角 经纬度
      const latMarginValue =
        mapLatLng._northEast.lat - mapLatLng._southWest.lat;
      const bottomH = latMarginValue / 5; // 产品要求，点击之后marker点需要偏地图下方一点，所以寻找了一个差值
      const { lat, lng } = coordinate;
      // panTo可以将map的中心点设为新的坐标值
      map.panTo({
        lat: lat + bottomH,
        lng,
      });
    },
    // 延迟
    setAsyncFun(time = 600) {
      return new Promise((resolve) => {
        const timer = setTimeout(() => {
          resolve();
          clearTimeout(timer);
        }, time);
      });
    },
    // 初始化视频弹框
    async _initVideoLayer() {
      this.dialogVisible = true;
      await this._nextTick();
      this.$refs.cameraVideoRef && this.$refs.cameraVideoRef.initModule();
      const that = this;
      const { currentMarkerTarget, _removeMarkerActiveClass } = this;
      const layerDomStr = $("#newVideo");
      layer.open({
        type: 1,
        anim: -1,
        skin: "anilayer slidecontrol cameralayer",
        resize: false,
        content: layerDomStr,
        title: false,
        area: ["659px", "399px"],
        shade: 0,
        success() {},
        end() {
          currentMarkerTarget &&
            _removeMarkerActiveClass(currentMarkerTarget._icon);
          that.dialogVisible = false;
          that.currentMarkerData = {
            id: null,
            displayName: "",
          };
        },
      });
    }, // 初始化网关弹框
    _initGatewayLayer() {
      let slScroll = null;
      let slScrollplus = null;
      const {
        currentMarkerData: { isStation, id },
      } = this;
      const _this = this;
      const sensorstr = `
				<div id="newVersion" class="equiplayer sensormonitor">
					<div class="equiplayercon">
						<p class="title"><span class="closebtn" onclick="window.layer.closeAll()"></span></p>
						<div class="monitorlistcon">
							<div class="monitorlist sensorlist">
								<div class="loader historyload" style="padding:23% 0 0 50%;">
									<div class="loader-inner ball-spin-fade-loader"><div>
									</div>
									<div></div><div></div><div></div><div></div><div></div><div></div><div></div>
								</div>
							</div>
						</div>
					</div>
				</div>`;
      // 打开弹框
      window.layer.open({
        type: 1,
        skin: `anilayer slidecontrol sensormonitorlayer ${
          isStation ? "hasImage" : ""
        }`,
        resize: false,
        content: sensorstr,
        title: false,
        area: ["659px", `${isStation ? "514px" : "399px"}`],
        shade: 0,
        anim: -1,
        async success() {
          const { controlList, sensorList } =
            await iotAccess.deviceDetailService({
              farmId: _this.farmId,
              deviceId: id,
            });
          const listTpl = _this._gatewayLayerTitle({ controlList, sensorList });
          const lists = ".sensormonitor .monitorlist ul li";
          let tempScrollInfo = null;
          $(".sensormonitorlayer .sensormonitor").html(listTpl);
          // 初始化滚动条
          if (sensorList.length > 3) {
            slScroll = initBScroll($(".sensormonitor .sensorlist").get(0));
            /* 以下三行是为了解决 低版本浏览器 滚动时莫名其妙的样式问题 */
            $(".sensormonitor .monitorlist>ul>li").css("overflow", "hidden");
            slScroll.scrollTo(0, -1);
            slScroll.scrollTo(0, 0);
          }
          if (controlList.length > 3) {
            slScrollplus = initBScroll(
              $(".sensormonitor .controlerlist").get(0)
            );
            $(".sensormonitor .monitorlist>ul>li").css("overflow", "hidden");
            slScrollplus.scrollTo(0, -1);
            slScrollplus.scrollTo(0, 0);
          }
          // 渲染传感设备的数字数据
          $(lists).each(function () {
            _this._zaNumber($(this).find(".sensoritem .sensornum"));
          });
          const listLength = $(lists).length;
          if (listLength > 1) {
            _this.hisBsFlag = false;
            _this.sensorHsBs = null;
            $(".sensormonitor .sensorlist ul").on(
              "click",
              ".senhistory_btn",
              function () {
                const liitem = $(this).closest("li");
                if (liitem.hasClass("active")) {
                  liitem
                    .find(".sensor_history")
                    .html('<div class="historycon"></div>');
                  $(this)
                    .closest("li")
                    .removeClass("active")
                    .siblings("li")
                    .removeClass("active")
                    .show();
                  // 滚动条还原
                  if (slScroll) {
                    slScroll.refresh();
                    slScroll.scrollTo(0, tempScrollInfo);
                    setTimeout(() => {
                      slScroll.refresh();
                    }, 300);
                  }
                } else {
                  // 记录滚动条位置
                  if (slScroll) {
                    tempScrollInfo = slScroll.y;
                  }
                  liitem
                    .addClass("active")
                    .siblings("li")
                    .removeClass("active")
                    .hide();
                  _this._initHistory(
                    liitem.find(".historycon"),
                    liitem.data("id")
                  );
                  _this.$nextTick(() => {
                    // 隐藏其他，展开显示
                    slScroll && slScroll.refresh();
                  });
                }
              }
            );
          } else if (listLength === 1) {
            _this.hisBsFlag = true;
            // 一个的时候 自动显示历史数据
            $(".sensormonitor .sensorlist>ul>li")
              .addClass("active")
              .siblings("li")
              .removeClass("active")
              .hide();
            _this._initHistory(
              $(".sensormonitor .sensorlist>ul>li").find(".historycon"),
              $(".sensormonitor .sensorlist>ul>li").data("id")
            );
            $(
              ".sensormonitor .sensorlist>ul>li span.splitline,.sensormonitor .sensorlist>ul>li .senhistory_btn"
            ).remove();
            $(".sensormonitor .sensorlist>ul>li .sensoritem").css(
              "width",
              "499px"
            );
            // 隐藏其他，展开显示
            slScroll && slScroll.destroy();
          }

          // tab切换显示
          $(".equiplayer p.title span.layertname").on("click", function () {
            if ($(".equiplayer p.title span.layertname").length > 1) {
              $(this)
                .addClass("active")
                .siblings("span.layertname")
                .removeClass("active");
            } else {
              $(this).addClass("blue");
            }

            // console.log($(this));
            $(".sensormonitor .equiplayercon .monitorlist")
              .eq($(this).index())
              .show()
              .siblings(".monitorlist")
              .hide();
            slScroll && slScroll.refresh();
            slScrollplus && slScrollplus.refresh();
            if (_this.hisBsFlag) {
              setTimeout(() => {
                _this.sensorHsBs && _this.sensorHsBs.refresh();
              }, 300);
            }
          });
          $(".equiplayer p.title span.layertname").first().trigger("click");
        },
        end() {
          _this._removeMarkerActiveClass(_this.currentMarkerTarget._icon);
          _this.currentMarkerData.player &&
            _this.currentMarkerData.player.destroy();
          _this.currentMarkerData = {
            id: null,
            displayName: "",
          };
        },
      });
    },
    // 网关弹窗的标题设置
    _gatewayLayerTitle(deviceData) {
      const { controlList, sensorList } = deviceData;
      const {
        currentMarkerData: { isStation, displayName },
      } = this;
      let listTpl = '<div class="equiplayercon"><p class="title">';
      // 是气象站，直接不管控制指标，只展示传感指标，且使用网关名称作为标题，使用气象站图片
      if (
        isStation ||
        controlList.length + sensorList.length <= 1 ||
        (controlList.length && !sensorList.length) ||
        (!controlList.length && sensorList.length)
      ) {
        listTpl += `<span class="layertname">${displayName}</span>`;
      } else {
        if (sensorList.length > 0) {
          listTpl += '<span class="layertname">环境监测</span>';
        }
        if (controlList.length > 0) {
          listTpl += '<span class="layertname">远程控制</span>';
        }
      }
      listTpl += `<span class="closebtn" onClick="window.layer.closeAll()"></span></p><div class="monitorlistcon ${
        isStation ? "weatherlayer" : ""
      }">`;
      if (isStation) {
        listTpl += this.getStationTpl(sensorList);
      }
      listTpl += this.getSensorProTpl(sensorList);
      listTpl += this.getControlProTpl(controlList);

      if (sensorList.length === 0 && controlList.length === 0) {
        listTpl +=
          '<div class="monitorlist nodata"><ul class="clearfix"><div class="nodata">暂无数据</div></ul></div>';
      }
      listTpl += "</div></div>";
      return listTpl;
    },

    // 生成气象站模板
    getStationTpl(sensorList) {
      let tpl = "";
      const wetherimg_a = require("@/assets/images/bs/farm-detail/weather_top.gif");
      const wetherimg_b = require("@/assets/images/bs/farm-detail/weather2_lower.png");
      const weatherTempData = {
        NumDirection: { name: "风向", value: null, isGray: true },
        Direction: { name: "风向", value: null, isGray: true },
        Temp: { name: "空气温度", value: null, isGray: true },
        Speed: { name: "风速", value: null, isGray: true },
        Rain: { name: "雨量", value: null, isGray: true },
        Humi: { name: "空气湿度", value: null, isGray: true },
        Pressure: { name: "大气压力", value: null, isGray: true },
        Light: { name: "光照强度", value: null, isGray: true },
        PM25: { name: "pm2.5", value: null, isGray: true },
      };
      sensorList.forEach(
        ({ unit, valueEnum, metricIdentifier, devicePropertyName }) => {
          if (weatherTempData[metricIdentifier]) {
            weatherTempData[metricIdentifier].name = devicePropertyName;
            weatherTempData[metricIdentifier].value =
              (valueEnum || "--") + (unit || "");
            weatherTempData[metricIdentifier].isGray = !valueEnum;
          }
        }
      );
      const Direction = weatherTempData.Direction.value
        ? weatherTempData.Direction
        : weatherTempData.NumDirection;
      tpl += `
			<div class="monitorlist weathercon lower">
				<div class="weather_bgimgs">
					<p><img style="width:286px" src="${wetherimg_a}" alt="" /></p>
					<p><img style="width:286px" src="${wetherimg_b}" alt="" /></p>
				</div>
				<div class="weather_items"> <div class="weatheritem">
					<p>${Direction.name}</p>
					<p class="value ${Direction.isGray ? "gray" : ""}">${
        Direction.value || "--"
      }</p>
				</div>
				<div class="weatheritem">
					<p>${weatherTempData.Speed.name}</p>
					<p class="value ${weatherTempData.Speed.isGray ? "gray" : ""}"">${
        weatherTempData.Speed.value || "--"
      }</p>
				</div>
				<div class="weatheritem">
					<p>${weatherTempData.Light.name}</p>
					<p class="value ${weatherTempData.Light.isGray ? "gray" : ""}"">${
        weatherTempData.Light.value || "--"
      }</p>
				</div>
				<div class="weatheritem">
					<p>${weatherTempData.Humi.name}</p>
					<p class="value ${weatherTempData.Humi.isGray ? "gray" : ""}"">${
        weatherTempData.Humi.value || "--"
      }</p>
				</div>
				<div class="weatheritem">
					<p>${weatherTempData.Temp.name}</p>
					<p class="value ${weatherTempData.Temp.isGray ? "gray" : ""}"">${
        weatherTempData.Temp.value || "--"
      }</p>
				</div>
				<div class="weatheritem">
					<p>${weatherTempData.PM25.name}</p>
					<p class="value ${weatherTempData.PM25.isGray ? "gray" : ""}"">${
        weatherTempData.PM25.value || "--"
      }</p>
				</div>
				<div class="weatheritem">
					<p>${weatherTempData.Pressure.name}</p>
					<p class="value ${weatherTempData.Pressure.isGray ? "gray" : ""}"">${
        weatherTempData.Pressure.value || "--"
      }</p>
				</div>
				<div class="weatheritem">
					<p>${weatherTempData.Rain.name}</p>
					<p class="value ${weatherTempData.Rain.isGray ? "gray" : ""}"">${
        weatherTempData.Rain.value || "--"
      }</p>
				</div>
			</div>
		</div>`;
      return tpl;
    },

    // 生成传感指标模板
    getSensorProTpl(list) {
      let tplStr = "";
      if (list.length > 0) {
        tplStr += '<div class="monitorlist sensorlist"><ul class="clearfix">';
        list.forEach(
          ({
            devicePropertyName,
            valueEnum,
            unit,
            devicePropertyId,
            enumFlag,
            metricIcon,
            ruleName,
            ruleColor,
          }) => {
            const isdiscrete_class = enumFlag ? "discrete" : "";
            tplStr += `<li data-id="${devicePropertyId}" class="${isdiscrete_class}">
					<div class="sensorlicon clearfix">
					<div class="sensoricon"><img src="${
            metricIcon ||
            "https://zaiot.oss-cn-hangzhou.aliyuncs.com/wechat/img/icon_eq_default.png"
          }" alt="" /></div>
					<div class="sensoritem">
					<p>${devicePropertyName}</p>`;
            tplStr += `<p>单位：<span>${unit || "无"}</span></p>
				<div class="sensor-section">${
          ruleName
            ? `<div class="rule-name" style="color:${
                ruleColor || "#FF994E"
              };border-color:${ruleColor || "#FF994E"}">${ruleName}</div>`
            : ""
        }<div class="sensornum za_number ${valueEnum ? "" : "no-value"}" num="${
              valueEnum || "--"
            }"></div></div></div>
				<span class="splitline"></span><div class="senhistory_btn"></div></div>
				<div class="sensor_history"><div class="historycon"></div></div></li>`;
          }
        );
        tplStr += "</ul></div>";
      }
      return tplStr;
    },
    // 生成控制指标模板
    getControlProTpl(list) {
      const CONTROLLER_IDENTIFY = {
        OCS: "OCS",
        SWITCH: "Switch",
      };
      let tplStr = "";
      if (list.length > 0) {
        tplStr +=
          '<div class="monitorlist controlerlist"><ul class="clearfix">';
        list.forEach(
          ({
            devicePropertyName,
            valueEnum,
            devicePropertyId,
            enumFlag,
            metricIdentifier,
            metricIcon,
            onlineFlag,
            unit,
          }) => {
            const isdiscrete_class = enumFlag ? "discrete" : "";
            const isOnoff =
              metricIdentifier === CONTROLLER_IDENTIFY.OCS ||
              metricIdentifier === CONTROLLER_IDENTIFY.SWITCH;
            tplStr += `<li  data-id="${devicePropertyId}" class="controler ${isdiscrete_class}">
					<div class="sensorlicon clearfix">
					<div class="sensoricon"><img src="${
            metricIcon ||
            "https://zaiot.oss-cn-hangzhou.aliyuncs.com/wechat/img/icon_eq_default.png"
          }" alt="" /></div> <div class="sensoritem"> <p>${devicePropertyName}</p>`;
            if (isOnoff) {
              if (!onlineFlag) {
                tplStr += `<div class="sensor-section"><div class="sensornum za_number" style="font-size: 24px; color: #2F896D; line-height: 32px; font-weight: normal;">离线</div></div>`;
              } else {
                tplStr += `<div class="sensor-section"><div class="sensornum za_number ${
                  valueEnum ? "" : "no-value"
                }" num="${valueEnum || "--"}"></div></div>`;
              }
            } else {
              tplStr += `<div class="sensor-section"><div class="sensornum za_number" style="color: #30E034; line-height: 32px; font-weight: normal;">${valueEnum}${unit}</div></div>`;
            }
            tplStr +=
              '</div></div> <div class="sensor_history"> <div class="historycon"></div> </div> </li>';
          }
        );
        tplStr += "</ul></div>";
      }
      return tplStr;
    },
    // 初始化视频播放插件 这里超级复杂，我也是复制老版本稍微修改了一下，还是不要看的比较好，复制直接用吧
    async _initVideoPlayer($dom, $video) {
      const that = this;
      const initvfn = () => {
        let errori = 0;
        let waittimer = null;
        $dom.html('<div id="videoitem" class="videobaseStyle"></div>');
        this.playerobj = initVideo({
          idName: "videoitem",
          src: $video.hlsUrl || $video.hlsUrlHd,
          width: "560",
          height: "315",
          poster: videoPoster,
        });
        waittimer = setInterval(() => {
          if ($("#videoitem").html() === "") {
            if (errori >= 3) {
              clearInterval(waittimer);
              $dom.html(
                '<p style="font-size: 20px; color: #71e8cf; text-align: center; line-height: 303px;">视频连接失败，请刷新浏览器重试</p>'
              );
              return false;
            }
            errori++;
          } else {
            clearInterval(waittimer);
          }
        }, 1000);
      };

      const initVideo = ({
        idName,
        src,
        width,
        height,
        poster,
        autoplay = true,
        live = true,
        flash = false,
        x5_player = true,
        x5_type = true,
        x5_fullscreen = true,
      } = {}) => {
        let player = new TcPlayer(idName, {
          m3u8: src,
          width,
          height,
          autoplay,
          coverpic: {
            style: "stretch",
            src: poster || "",
          },
          live,
          flash,
          x5_player,
          x5_type,
          x5_fullscreen,
          listener(msg) {
            if (!player) return false;
            const loadingEl = msg.src.player.el.querySelector(".vcp-loading");
            if (msg.type === "error") {
              if (player.options.src) {
                loadingEl.setAttribute("style", "display:none;");
                player.timer_errordoing = setTimeout(() => {
                  if (!player.playing() && player.errorreload_i < 3) {
                    // 是否已在播放
                    const textContent = $video.hlsUrl ? "流畅" : "高清";
                    if (document.querySelector(".switch-load-btn"))
                      document.querySelector(".switch-load-btn").innerHTML =
                        textContent; // 加载报错 下方加载的是 流畅视频源
                    player.load(player.options.src);
                    player.errorreload_i++;
                    loadingEl.setAttribute("style", "display:block;");
                  } else {
                    loadingEl.setAttribute("style", "display:none;");
                  }
                  clearTimeout(player.timer_errordoing);
                }, 3000);
              }
            } else if (msg.type === "playing") {
              clearTimeout(player.timer_errordoing);
              loadingEl.setAttribute("style", "display:none;");
            }

            if (!player.initreflashbtn) {
              // 初始化
              // load
              const switchLoadBtn = document.createElement("div");
              let textContent = $video.hlsUrl ? "流畅" : "高清";
              switchLoadBtn.setAttribute("class", "switch-load-btn");
              switchLoadBtn.innerText = textContent;
              switchLoadBtn.addEventListener("click", () => {
                switch (textContent) {
                  case "流畅":
                    if (!$video.hlsUrlHd) {
                      that.$message({
                        type: "warning",
                        message: "当前视频仅支持流畅播放",
                        center: true,
                      });
                      return false;
                    }
                    player.load($video.hlsUrlHd);
                    textContent = "高清";
                    break;
                  case "高清":
                    if (!$video.hlsUrl) {
                      that.$message({
                        type: "warning",
                        message: "当前视频仅支持高清播放",
                        center: true,
                      });
                      return false;
                    }
                    player.load($video.hlsUrl);
                    textContent = "流畅";
                    break;
                  default:
                    break;
                }
                that.$message({
                  type: "success",
                  message: `已切换至${textContent}播放`,
                  center: true,
                });
                switchLoadBtn.innerText = textContent;
              });
              $video.hlsUrl !== $video.hlsUrlHd &&
                msg.src.player.el
                  .querySelector(".vcp-controls-panel")
                  .appendChild(switchLoadBtn);

              player.initreflashbtn = true;
              const div = document.createElement("div");
              div.className = "vcp-reflashbtn";
              div.addEventListener("click", () => {
                player &&
                  player.video &&
                  player.video.hls &&
                  player.video.hls.stopLoad();
                loadingEl.setAttribute("style", "display:block;");
                clearTimeout(player.timer_errordoing);
                player.load(
                  textContent === "高清" ? $video.hlsUrlHd : $video.hlsUrl
                );
              });
              setTimeout(() => {
                msg.src.player.el
                  .querySelector(".vcp-controls-panel")
                  .appendChild(div);
              }, 600);
            }
          },
        });
        player.timer_errordoing = null;
        player.errorreload_i = 0;
        player.initreflashbtn = false;
        player.stopload = () => {
          player &&
            player.video &&
            player.video.hls &&
            player.video.hls.stopLoad();

          player = null;
        };
        return player;
      };

      this.playerobj && this.playerobj.destroy();
      await this._initTcPlayer();
      initvfn();
    }, // 获取TcPlayer
    _initTcPlayer() {
      return new Promise((resolve) => {
        if (!window.TcPlayer) {
          $.getScript(
            "https://imgcache.qq.com/open/qcloud/video/vcplayer/TcPlayer-2.3.2.js",
            () => {
              resolve();
            }
          );
        } else {
          resolve();
        }
      });
    },
    // 历史数据生成
    async _initHistory(mountPoint, devicePropertyId) {
      const echartfn = async (xData, yData, domobj, unit) => {
        if (!domobj) {
          return false;
        }
        if (!xData.length && !yData.length) {
          domobj.innerHTML =
            '<div style="padding-top: 100px; text-align: center; font-size: 18px; color: #2CD2A9;">近30天暂无历史数据<div>';
          return;
        }
        var myChart = echarts.init(domobj);
        var option = {
          title: { show: false, text: "", subtext: "" },
          tooltip: {
            show: true,
            trigger: "axis",
            borderColor: "#64C3A4",
            backgroundColor: "rgba(100,195,164,1)",
            padding: [5, 10, 2],
            textStyle: { color: "#fff" },
            formatter: function (a) {
              return `<p class='echartBox' style='text-align:left;line-height:24px;padding:3px;'>${
                a[0].name
              }<br/>数值：${
                a[0].value === undefined ? "--" : a[0].value
              }${unit.replace(/无/, "")}</p>`;
            },
            axisPointer: {
              lineStyle: { color: "#64C3A4", width: 1 },
              crossStyle: { color: "#00E5FF", width: 3 },
            },
          },
          legend: {
            data: [],
          },
          toolbox: {
            show: false,
          },
          calculable: false,
          xAxis: [
            {
              type: "category",
              boundaryGap: false,
              data: xData,
              splitLine: {
                show: false,
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: "#73867A",
                },
                formatter: function (a) {
                  return a.split(" ")[0] + "\n" + a.split(" ")[1];
                },
              },
              axisLine: {
                lineStyle: { color: "rgba(255,255,255,0.1)", width: 1 },
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              splitLine: {
                show: true,
                lineStyle: { color: "rgba(48,138,110,0.2)" },
              },
              axisLabel: { show: true, textStyle: { color: "#73867A" } },
              axisLine: {
                lineStyle: { color: "rgba(255,255,255,0.1)", width: 1 },
              },
            },
          ],
          grid: {
            left: 48,
            right: 23,
            top: 20,
            bottom: 43,
            borderWidth: 0,
          },
          series: [
            {
              name: "传感器历史数据",
              type: "line",
              smooth: true,
              clickable: false,
              itemStyle: {
                normal: {
                  color: "#73867A",
                  lineStyle: {
                    color: "#308A6E",
                  },
                  areaStyle: {
                    color: {
                      type: "linear",
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: "rgba(109,250,115,0.4)", // 0% 处的颜色
                        },
                        {
                          offset: 1,
                          color: "rgba(100,195,164,0)", // 100% 处的颜色
                        },
                      ],
                      global: false, // 缺省为 false
                    },
                  },
                },
                emphasis: {
                  lineStyle: {
                    color: "#fff",
                  },
                },
              },
              data: yData,
              symbol: "circle",
              symbolSize: 1,
              showAllSymbol: true,
            },
          ],
        };
        var maxstrlen = Math.max.apply(null, yData);
        if (maxstrlen.toString().length > 4) {
          var ww = (maxstrlen.toString().length - 4) * 7 + 50;
          option.grid.x = ww;
        }
        myChart.setOption(option);
      };
      const initData = (xdata, ydata, domobj) => {
        var htmlstr = "";
        htmlstr +=
          '<div class="control_timeline" ref="controltimeline"><ul class="clearfix">';
        for (var i = 0; i < xdata.length; i++) {
          htmlstr += `<li><span class="pointer"></span><p><span class="fl">${xdata[i]}</span><span class="fr">${ydata[i]}</span></p> </li>`;
        }
        htmlstr += "</ul></div>";
        if (xdata.length === 0) {
          domobj.innerHTML =
            '<div style="padding-top: 100px; text-align: center; font-size: 18px; color: #2CD2A9;">近30天暂无历史数据<div>';
          return false;
        }
        domobj.innerHTML = htmlstr;
        this.sensorHsBs = initBScroll(
          domobj.querySelectorAll(".control_timeline")[0]
        );
      };
      mountPoint.html(
        '<div class="loader historyload"><div class="loader-inner ball-spin-fade-loader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>'
      );
      const {
        deviceAttr: { enumFlag, unit },
        historyList,
      } = await iotAccess.devicePropertyHistoryService({
        farmId: this.farmId,
        dateNum: 30,
        dateType: 1,
        devicePropertyId,
      });
      const xdata = [];
      const ydata = [];
      historyList.forEach(({ timestamp, value }) => {
        !enumFlag && xdata.push(new Date(timestamp).format("MM.dd hh:mm"));
        enumFlag && xdata.push(dateFormatMapping(timestamp, "yyyy.MM.dd"));
        ydata.push(value);
      });
      !enumFlag && echartfn(xdata, ydata, mountPoint.get(0), unit || "无");
      enumFlag && initData(xdata, ydata, mountPoint.get(0));
    },
    _zaNumber(ele) {
      var num = ele.attr("num");
      if (!isNaN(num)) {
        num = Number(num) + "";
        if (num.split("").length > 0) {
          var arr = num.split("");
          var numstr = "";
          for (var i = 0; i < arr.length; i++) {
            if (arr[i] == ".") {
              numstr += '<span class="number_pointer"></span>';
            } else if (!isNaN(arr[i])) {
              numstr += '<span class="number_' + arr[i] + '"></span>';
            } else {
              numstr += '<span class="number_other">' + arr[i] + "</span>";
            }
          }
          ele.html(numstr);
          setTimeout(function () {
            ele.find("span").not(".number_pointer").addClass("aninum");
          }, 0);
        }
      } else {
        let htmlstr = num;
        if (num === "停") {
          htmlstr = "<i style='color:#FEBD4D;font-style:normal;'>停</i>";
        } else if (num === "开") {
          htmlstr = "<i style='color:#30E034;font-style:normal;'>开</i>";
        } else if (num === "关") {
          htmlstr = "<i style='color:#FD4F4F;font-style:normal;'>关</i>";
        }
        ele.html(htmlstr);
      }
    },
    _nextTick(time = 0, cb = () => {}) {
      return new Promise((resolve) => {
        setTimeout(async () => {
          await this.$nextTick();
          await cb();
          resolve(true);
        }, time);
      });
    },
  },
};
export default farmdetailIotNewMixin;
